var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpTopicsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.8799V10.8799H3L10 3.87988L17 10.8799H13V16.8799H7Z",
    fill: "#9293FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTopicsIcon);
export default __webpack_public_path__ + "static/media/up-topics-icon.ce6a15e8d15186db36b9c8e5ec745197.svg";
export { ForwardRef as ReactComponent };